import { Quote } from "lucide-react";
import { Card } from "@/components/ui/card";
import SectionHeader from "@/components/SectionHeader";
import testimonialMarcos from "@/assets/testimonial-marcos.png";
import testimonialHelene from "@/assets/testimonial-helene.png";
import testimonialTom from "@/assets/testimonial-tom.png";

const ClientFeedbacks = () => {
  const feedbacks = [{
    text: "Eine erfolgsfokussierte Zusammenarbeit, die sich wie Freundschaft anfühlt. Es macht immer wieder Spaß, Ideen gemeinsam Realität werden zu lassen.",
    author: "Marcos DaCosta",
    company: "Costa Calisthenics",
    image: testimonialMarcos
  }, {
    text: "Das Team von aivinity weiß genau was es tut. Danke für die tolle Zusammenarbeit und wir freuen uns auf unsere gemeinsamen, zukünftigen Projekte.",
    author: "Helene",
    company: "22 Studios Nürnberg",
    image: testimonialHelene
  }, {
    text: "Ein Team, das wie ein Uhrwerk zusammenarbeitet. Jedes Rad greift in das andere und am Ende kamen wir gemeinsam zu dem Ergebnis, welches vorhergesagt wurde.",
    author: "Tom Rothenhäusler",
    company: "Leadfeed Marketing GmbH",
    image: testimonialTom
  }];

  return (
    <section className="py-12 md:py-20 lg:py-24 bg-gradient-to-b from-background via-background to-background">
      <div className="container mx-auto px-4 md:px-6">
        <SectionHeader
          badge="Feedback"
          title="Was unsere Kunden sagen"
          highlightedWord="Kunden"
          description="Echtes Feedback von echten Partnern"
          className="mb-10 md:mb-14"
        />

        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-6 md:gap-8">
          {feedbacks.map((feedback, index) => (
            <Card 
              key={index} 
              className="p-6 md:p-8 bg-card border-border hover:border-accent/50 transition-all duration-300 hover:shadow-lg hover:shadow-accent/10 animate-fade-in" 
              style={{ animationDelay: `${index * 0.1}s` }}
            >
              <Quote className="w-8 md:w-10 h-8 md:h-10 text-accent mb-4 md:mb-6" />
              
              <p className="text-sm md:text-base text-foreground leading-relaxed mb-4 md:mb-6 italic">
                "{feedback.text}"
              </p>
              
              <div className="border-t border-border pt-3 md:pt-4 flex items-center gap-3">
                <img 
                  src={feedback.image} 
                  alt={feedback.author}
                  className="w-12 h-12 rounded-full object-cover"
                />
                <div>
                  <p className="font-bold text-sm md:text-base text-foreground">{feedback.author}</p>
                  <p className="text-xs md:text-sm text-muted-foreground">{feedback.company}</p>
                </div>
              </div>
            </Card>
          ))}
        </div>
      </div>
    </section>
  );
};

export default ClientFeedbacks;
